
import { Vue, Component } from 'vue-property-decorator'
import Project from '@/types/project'
import moment from 'moment'

@Component({
  components: {}
})

export default class ProjectEditDatesTab extends Vue {
  settings = {
    routeNames: { list: 'projects', show: 'projectShow', edit: 'projectEdit' },
    routeParamKey: 'projectId',
    functionNames: { setCurrent: 'setCurrentProject', save: 'saveProject' },
    getterNames: { current: 'currentProject', loading: 'loadingProject', errors: 'projectErrors' }
  }

  moment () : moment.Moment {
    return moment()
  }

  get currentItem () : Project {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
